// extracted by mini-css-extract-plugin
export var typeLarge = "Button-module--type-large--2MQKI";
export var typeMedium = "Button-module--type-medium--oIrz1";
export var typeBody = "Button-module--type-body--wsRh9";
export var homeIcon = "Button-module--home-icon--tUWc6";
export var btn = "Button-module--btn--Gb2fD";